import { useAuthStore } from '@/stores/AuthStore';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [{ path: '', component: () => import('pages/LoginPage.vue') }],
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    beforeEnter: async () => {
        const authStore = useAuthStore();
        if (authStore.user == null) {
          await authStore.getUserDetails()
        }
    },
    children: [
      { path: '', component: () => import('pages/IndexPage.vue') },
      { path: 'exams', component: () => import('pages/ExamsPage.vue') },
      { path: 'exams/:examId/questions', component: () => import('pages/ExamQuestionsPage.vue') },
      { path: 'exams/:examId/attempt', component: () => import('pages/ExamAttemptPage.vue') },
      { path: 'attempts/:attemptId', component: () => import('pages/AttemptDetailPage.vue') },
      { path: 'settings', component: () => import('pages/SettingsPage.vue') },
      { path: 'admin', component: () => import('pages/AdminPage.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
